/** "What it really costs to leave basic economy, and when it’s worth it": metadata (the article is in ../bodies/basic-economy-real-cost.js). */
export default {
  slug: 'basic-economy-real-cost',
  category: 'Research',
  label: 'Research · November 2026',
  title: 'What it really costs to leave basic economy, and when it’s worth it',
  seoTitle: 'Basic Economy vs Main Cabin: Is It Worth It? (2026)',
  description: 'On 101 flights where the airline sold both, leaving basic economy cost a median $45 (33%). See the cost by airline, what basic left out and the break-even math.',
  dek: 'We priced each airline’s basic fare against its next fare up on the exact same flights. The median gap was $45, and on some airlines a single checked-bag fee covered it.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'How much more is main cabin than basic economy?',
      a: 'On 101 flights where the airline sold both, the next fare up cost a median $45 more one way, or 33%. Among airlines with at least five comparisons, it ranged from $20 on Aeromexico to $55 on American.',
    },
    {
      q: 'Is basic economy worth it?',
      a: 'It’s a good deal when you’ll travel light, don’t need a particular seat and are sure of your dates. If you’d pay for a checked bag, a carry-on, a seat assignment or a change, add those fees up and compare them with the upgrade price; the upgrade is often cheaper.',
    },
    {
      q: 'What do you give up with basic economy?',
      a: 'It depends on the airline. In our data, United’s basic fare listed no carry-on bags, Delta’s no seat selection or mileage, American’s and Southwest’s no ticket changes, and Frontier’s charged for seat selection and changes.',
    },
    {
      q: 'Does basic economy include a carry-on bag?',
      a: 'Not always. United’s Basic Economy listed no carry-on bags, and Frontier’s Economy Bundle listed one free carry-on that its Basic Fare didn’t include. Check the fare details for your flight before you book.',
    },
    {
      q: 'Can you change a basic economy flight?',
      a: 'Often not, or only for a fee. American’s, Southwest’s and Aeromexico’s basic fares listed no changes, while Delta’s and Frontier’s allowed changes for a fee. Most of their standard fares listed free changes (Aeromexico’s listed changes for a fee), though you may still pay any fare difference.',
    },
  ],
  related: [
    'do-cheap-flight-sites-have-cheaper-fares',
    'when-to-book-flights-fare-data',
    'cheapest-day-to-fly',
  ],
};
